<template>
    <div class="column-box">
        <img class="column-title" :src="columntEducationTitle" />
        <div class="column" ref="column">
            <div class="column-list">
                <div class="column-item column-education" v-for="(column, i) of columnEducations" :key="i"
                    @click="chooseColumn(column)">
                    <i class="column-cover"
                        :style="{ backgroundImage: 'url(' + column.config.cover + '!250x160)' }"></i>
                    <div class="column-name" :class="{ 'ellipsis': phoneMode, 'ellipsis2': !phoneMode }"
                        :style="{ 'background': column.backgroundColor }">{{ column.name }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "colunm-list",
    components: {},
    data() {
        return {
            columntPublishTitle: "https://img.lessonplan.cn/IMG/yuanxi/images/home/column-publish.png",
            columntEducationTitle: "https://img.lessonplan.cn/IMG/yuanxi/images/home/column-education.png",
        }
    },
    computed: {
        ...mapState({
            columnPublishs: (state) => state.columnList.filter((item) => item.type == "publish") || [],
            columnEducations: (state) => state.columnList.filter((item) => item.type == "education") || [],
            phoneMode: 'phoneMode'
        })
    },
    mounted() {

    },
    methods: {
        //选择分栏
        chooseColumn(column) {
            const { pk_digital_column_id } = column;
            this.$router.push(`/column/${pk_digital_column_id}`);
        },
    },
}
</script>

<style lang="scss" scoped>
.column-box {
    margin: 20px auto;
    width: 100%;
    margin-bottom: 100px;
    text-align: center;

    .column-title {
        padding-bottom: 20px;
    }

    .column-subtitle {
        font-size: 18px;
        margin-bottom: 30px;
    }

    .column {
        overflow-x: auto;
        background: #f5f5f550;
        padding: 40px 20px;

        .column-list {
            max-width: 1100px;
            margin: 0 auto;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            margin: 0 auto;

            .column-item {
                width: calc(100%/5 - 20px);
                background: transparent;
                color: #666666;
                margin: 10px;
                transition: all .3s ease;
                cursor: pointer;
                border-radius: 5px;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

                @media screen and (max-width: 1000px) {
                    & {
                        width: calc(100%/4 - 20px);
                    }
                }

                &.column-education {
                    .column-cover {
                        height: 180px;
                    }

                    .column-name {
                        height: auto;
                        padding: 10px 0;
                        color: #ffffff;
                        background-color: #666666;
                        box-shadow: inset 0 0 20px #ffffff2e;
                    }
                }

                &:hover {
                    box-shadow: var(--box-shadow);
                    transform: translateY(-15px);
                    -webkit-transform: translateY(-15px);
                }

                .column-cover {
                    display: block;
                    height: 140px;
                    width: 100%;
                    background-size: cover;
                    background-position: center;
                    border-radius: 5px 5px 0 0;
                    background-color: var(--primary-color);
                    position: relative;
                }

                .column-name {
                    text-align: center;
                    padding: 20px;
                    border-radius: 0 0 5px 5px;
                    font-size: 15px;
                    height: 88px;
                    background-color: #ffffff;
                }
            }
        }
    }

}


#content {
    &.phone-mode {

        .column-box {
            .column-title {
                width: 100%;
                height: auto;
                margin-bottom: 10px;
            }

            .column {
                .column-list {
                    .column-item {
                        width: calc(50% - 20px);
                        margin: 10px auto;

                        .column-cover {
                            height: 130px;
                        }

                        .column-name {
                            font-size: 12px;
                        }
                    }
                }
            }
        }

    }
}
</style>